import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import GhStars from './GhStars';
import ShinobiTable from '../Demo/Demo';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "window-table"
    }}>{`Window-Table`}</h1>
    <p>{`Window Table is a fixed data table for React, which is capable of rendering thousands of rows of data
without compromising performance. The following table renders `}<strong parentName="p">{`100,000`}</strong>{` rows of data.`}</p>
    <ShinobiTable rowClassName={index => index % 2 === 0 ? 'even-row' : 'odd-row'} mdxType="ShinobiTable" />
    <p><strong parentName="p">{`Support us by giving a Star on Github!`}</strong></p>
    <GhStars mdxType="GhStars" />
    <p>{`Now Let's have a quick look at the minimal code we needed to get started.
Note that we are using `}<a parentName="p" {...{
        "href": "https://getbootstrap.com/docs/4.1/content/tables/"
      }}>{`bootstrap`}</a>{` table classes for styling.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "harmony",
        "harmony": true
      }}>{`<Html5Table
    data={data}
    columns={columns}
    className="table-sm"
    headerClassName="thead-dark"
/>
`}</code></pre>
    <h2 {...{
      "id": "html5-tags-"
    }}>{`HTML5 tags 💅`}</h2>
    <p>{`One of the biggest pain points in using a fixed data table is styling. In contrast, basic HTML5 tags based tables
can be easily styled using an off the shelf style system like bootstrap.`}</p>
    <p>{`Thus, you can optionally use default HTML 5 tags like `}<inlineCode parentName="p">{`table`}</inlineCode>{`, `}<inlineCode parentName="p">{`thead`}</inlineCode>{`, `}<inlineCode parentName="p">{`tbody`}</inlineCode>{`, `}<inlineCode parentName="p">{`tr`}</inlineCode>{`, `}<inlineCode parentName="p">{`td`}</inlineCode>{` and `}<inlineCode parentName="p">{`th`}</inlineCode>{` for the table
nodes by importing the `}<inlineCode parentName="p">{`HTML5Table`}</inlineCode>{` component from this library.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "harmony",
        "harmony": true
      }}>{`import { Html5Table } from 'window-table';
`}</code></pre>
    <h2 {...{
      "id": "tiny-footprint-"
    }}>{`Tiny Footprint 👶`}</h2>
    <p>{`The code for this library is written in a way which minimizes the lines of code
while still allowing the users to customize and extend it however they want.`}</p>
    <h2 {...{
      "id": "alternatives"
    }}>{`Alternatives`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mckervinc.github.io/react-fluid-table/#/"
        }}>{`React Fluid Table`}</a>{`,
a drop in replacement for window-table with a ton of more features.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://autodesk.github.io/react-base-table"
        }}>{`React Base Table`}</a>{`,
a library which also offers a ton more features, with a slightly different API.`}</li>
    </ul>
    <h2 {...{
      "id": "contributions-welcome"
    }}>{`Contributions welcome`}</h2>
    <p>{`I, the author of this library, have been unable to provide support for the issues opened in the library
in the past few months. Contributions highly appreciated.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      